export const TIPOS_EMAIL_CADASTRO = [
  {
    nome: "@sme.prefeitura.sp.gov.br",
    uuid: 0,
  },
];
